// extracted by mini-css-extract-plugin
export default {"overlay-popover":"OverlayPopover_overlay-popover__Y9hwc","has-arrow":"OverlayPopover_has-arrow__UI9d-"};